import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { getLPointShowValue, GetMoneyValue } from "../../../../Api/ApiCommon";
import { GetSubscriptionSetData } from "../../../../Api/ServiceDatas";
import { useApi } from "../../../../hooks/useApi";
import { IPay } from "../../../../pages/Pay/PayInfo";
import Loader from "../../../DefaultStyles/Loader";
import { TableBodyItem } from "../../../Table/Table";
import MoneyWithdraw from "./PayInfoDetail/MoneyWithdraw";
import PartyEndRew from "./PayInfoDetail/PartyEndRew";
import PartyEndRewBreak from "./PayInfoDetail/PartyEndRewBreak";
import PartyEndRewExit from "./PayInfoDetail/PartyEndRewExit";
import PartyFeePay from "./PayInfoDetail/PartyFeePay";
import PartyFeeSave from "./PayInfoDetail/PartyFeeSave";
import PartyPenaltyPay from "./PayInfoDetail/PartyPenaltyPay";
import { PayReason } from "../../../../Api/Types";
import { getSubsNameBySubsId3 } from "../../../../AdminApi/3.0_utils";
import LinkidMoneyDeducted from "./PayInfoDetail/LinkidMoneyDeducted";
import LinkidMoneyCharge from "./PayInfoDetail/LinkidMoneyCharge";
import moment from "moment";

export interface PayInfoDetailProps {
  data: IPay;
  isNewVersion?: boolean;
}

export interface IPayMemberData {
  uid: number;
  fowner: number;
}

export default function PayInfoDetail({
  data,
  isNewVersion,
}: PayInfoDetailProps) {
  const [fetch, setFetch] = useState(false);
  const [memberData, setMemberData] = useState<IPayMemberData[]>([]);

  // console.log(moment(data?.time).format("YYYY-MM-DD"));
  const date = moment(data?.time).format("YYYY-MM-DD");
  const { response, loading } = useApi({
    method: "get",
    url: fetch ? `pay/member?partyid=${data?.partyid}&date=${date}` : undefined,
  });

  useEffect(() => {
    if (data?.type === 3 || data?.type === 4) {
      setFetch(true);
    }
  }, [data?.type]);

  useEffect(() => {
    if (response) {
      setMemberData(response?.data);
    }
  }, [response]);

  return (
    <>
      <PayDetailContainer>
        {/* subscription 이름 */}
        <PayDetailItem>
          <PayDetailItemContent>
            {getSubsNameBySubsId3(data?.servsubsid)}
          </PayDetailItemContent>
        </PayDetailItem>
        {/* partyid */}
        <PayDetailItem>
          <PayDetailItemContent>
            {data?.partyid > 0 ? data?.partyid : ""}
          </PayDetailItemContent>
        </PayDetailItem>

        {/* 파티 요금 결제 */}
        {(data?.type === PayReason.Ch_PartyFee ||
          data?.type === PayReason.Ch_PartyFee_PayDay ||
          data?.type === PayReason.Ch_PartyFee_Before ||
          data?.type === PayReason.Ch_PartyFee_Proxy) && (
          <PartyFeePay data={data} />
        )}

        {/* 파티 위약금 결제 */}
        {(data?.type === PayReason.Ch_PenaltyFee ||
          data?.type === PayReason.Ch_GuaranteeFee ||
          data?.type === PayReason.Ch_eat_n_run) && (
          <PartyPenaltyPay data={data} memberData={memberData} />
        )}

        {/* 파티 요금 적립 */}
        {(data?.type === PayReason.Re_PartyFee_PayDay ||
          data?.type === PayReason.Re_PartyFee_PartyEnd ||
          data?.type === PayReason.Re_EndRew_No_Reason_Break ||
          (isNewVersion
            ? data?.type === PayReason.Re_EndCompensation
            : false)) && (
          <PartyFeeSave data={data} isNewVersion={isNewVersion} />
        )}

        {/* 파티 종료 적립 */}
        {(data?.type === PayReason.Re_EndRew ||
          data?.type === PayReason.Re_Compensation ||
          (isNewVersion
            ? false
            : data?.type === PayReason.Re_EndCompensation)) && (
          <PartyEndRew data={data} isNewVersion={isNewVersion} />
        )}

        {/* 파티 종료 적립 (탈퇴 / 무책탈퇴) */}
        {(data?.type === PayReason.Re_EndRew_Exit ||
          data?.type === PayReason.Re_No_Reason_Exit ||
          data?.type === PayReason.Re_1_Exit ||
          data?.type === PayReason.Re_EndRew_Before_Exit) && (
          <PartyEndRewExit data={data} />
        )}

        {/* 파티 종료 적립 (해산 / 무책해산) || 파티 종료 적립 (일몰 해산 종료)*/}
        {(data?.type === PayReason.Re_EndRew_Break ||
          data?.type === PayReason.Re_PartyFee_PartyEnd_Sset ||
          data?.type === PayReason.Re_No_Reason_Broken ||
          data?.type === PayReason.Re_1_Broken ||
          data?.type === PayReason.Re_Youtube_Broken ||
          data?.type === PayReason.Re_Youtube_Broken_PG) && (
          <PartyEndRewBreak data={data} />
        )}

        {/* 링키드 머니 인출 */}
        {data?.type === PayReason.WithDraw && <MoneyWithdraw data={data} />}

        {/* 링키드 머니 차감 */}
        {data?.type === PayReason.Admin_Cut_Money && (
          <LinkidMoneyDeducted data={data} />
        )}

        {/* 링키드 머니 충전 */}
        {data?.type === PayReason.Admin_Charge_Money && (
          <LinkidMoneyCharge data={data} />
        )}

        <PayDetailItem colSpan={4} />
      </PayDetailContainer>

      {/* 합계 */}
      {data?.type !== PayReason.WithDraw && (
        <PayDetailTotalContainer>
          <PayDetailItem colSpan={2} />
          <PayDetailItem style={{ fontWeight: "bold" }}>합계</PayDetailItem>
          <PayDetailItem style={{ fontWeight: "bold" }}>
            {GetMoneyValue(
              data?.type === PayReason.Re_PartyFee_PartyEnd ||
                data?.type === PayReason.Re_EndRew_No_Reason_Break ||
                data?.type === PayReason.Re_PartyFee_PayDay ||
                data?.type === PayReason.Re_EndCompensation ||
                data?.type === PayReason.Re_EndCompensation_Sset
                ? data?.log?.amount
                : data?.log?.amount -
                    (data?.log?.point ?? 0) -
                    (data?.log?.pg ?? 0),
            )}
          </PayDetailItem>
          <PayDetailItem colSpan={4} />
        </PayDetailTotalContainer>
      )}

      {/* 결제 정보 */}
      {(data?.log?.money > 0 ||
        data?.log?.point > 0 ||
        data?.log?.charge > 0 ||
        data?.log?.amount - data?.log?.point > 0) && (
        <PayDetailContainer>
          <PayDetailItem colSpan={2} />
          <PayDetailItem>
            <>
              {data?.type === 54 ||
              data?.type === 55 ||
              data?.type === PayReason.Re_No_Reason_Exit ||
              data?.type === PayReason.Re_1_Exit ||
              data?.type === PayReason.Re_No_Reason_Broken ||
              data?.type === PayReason.Re_1_Broken ||
              data?.type === PayReason.Re_Youtube_Broken ||
              data?.type === PayReason.Re_Youtube_Broken_PG ? (
                <>
                  {(data?.log?.money > 0 ||
                    data?.log?.amount -
                      data?.log?.point -
                      (data?.log?.pg ?? 0) >
                      0) && (
                    <PayDetailItemText>링키드 머니 환불</PayDetailItemText>
                  )}
                  {data?.log?.point > 0 && (
                    <PayDetailItemText>링키드 포인트 환불</PayDetailItemText>
                  )}
                </>
              ) : (
                <>
                  {data?.log?.money > 0 && (
                    <PayDetailItemText>링키드 머니 사용</PayDetailItemText>
                  )}
                  {data?.log?.charge > 0 && (
                    <PayDetailItemText>
                      {`${data?.log?.cdname} 결제`} ({data?.pg})
                    </PayDetailItemText>
                  )}
                </>
              )}
            </>
          </PayDetailItem>
          <PayDetailItem>
            {data?.type === 54 ||
            data?.type === 55 ||
            data?.type === PayReason.Re_No_Reason_Exit ||
            data?.type === PayReason.Re_1_Exit ||
            data?.type === PayReason.Re_No_Reason_Broken ||
            data?.type === PayReason.Re_1_Broken ||
            data?.type === PayReason.Re_Youtube_Broken ||
            data?.type === PayReason.Re_Youtube_Broken_PG ? (
              <>
                {/* 링키드 머니 환불 */}
                {(data?.log?.money ||
                  data?.log?.amount - data?.log?.point - (data?.log?.pg ?? 0) >
                    0) && (
                  <PayDetailItemText>
                    {data?.log?.money
                      ? GetMoneyValue(data?.log?.money)
                      : GetMoneyValue(
                          data?.log?.amount -
                            data?.log?.point -
                            (data?.log?.pg ?? 0),
                        )}
                  </PayDetailItemText>
                )}

                {/* 링키드 포인트 환불 */}
                {data?.log?.point > 0 && (
                  <PayDetailItemText>
                    {getLPointShowValue(data?.log?.point)}
                  </PayDetailItemText>
                )}
              </>
            ) : (
              <>
                {/* 링키드 머니 사용 */}
                {data?.log?.money > 0 && (
                  <PayDetailItemText>
                    {GetMoneyValue(data?.log?.money)}
                  </PayDetailItemText>
                )}

                {/* 카드 결제  */}
                {data?.log?.charge > 0 && (
                  <PayDetailItemText>
                    {GetMoneyValue(data?.log?.charge)}
                  </PayDetailItemText>
                )}
              </>
            )}
          </PayDetailItem>
          <PayDetailItem colSpan={4} />
        </PayDetailContainer>
      )}

      {/* MCID */}
      <PayDetailTotalContainer
        style={{
          backgroundColor:
            data?.type === 51 ||
            data?.type === 52 ||
            data?.type === 53 ||
            data?.type === 56
              ? "#f5f5f5"
              : "#ebecf0",
        }}
      >
        <PayDetailGrayText style={{ fontWeight: "bold" }}>
          Mcid
        </PayDetailGrayText>
        <PayDetailGrayText></PayDetailGrayText>
        <PayDetailGrayText style={{ fontWeight: "bold" }}>
          {data?.mcid}
        </PayDetailGrayText>

        <PayDetailGrayText colSpan={5} />
      </PayDetailTotalContainer>

      {loading && <Loader />}
    </>
  );
}

const PayDetailContainer = styled.tr`
  padding-top: 10px;
  width: 100%;
  height: auto;
  background-color: #f5f5f5;
`;

const PayDetailItem = styled(TableBodyItem)`
  padding: 9px 10px;
  vertical-align: top;
`;

export const PayDetailTotalContainer = styled(PayDetailContainer)`
  padding: 0;
  background-color: #ebecf0;
`;

const PayDetailGrayText = styled(PayDetailItem)`
  color: #858c97;
`;

const PayDetailItemText = styled.div`
  height: 36px;
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 500;
  line-height: 22.5px;
  text-align: left;
`;

const PayDetailItemContent = styled.div`
  height: 36px;
  display: flex;
  align-items: center;
`;
